<template>
  <div class="body">
      <!-- 左侧结束 -->
      <el-form ref="form" :model="form" label-width="100px" v-loading="loading">
        <el-form-item label="您的姓名：">
          <el-input placeholder="请输入您的姓名" v-model="form.lxname"></el-input>
        </el-form-item>
        <el-form-item label="您的电话：">
          <el-input placeholder="请输入客服电话" v-model="form.kftel"></el-input>
        </el-form-item>
        <el-form-item label="咨询内容：" >
          <el-input
            class="textarea-ipt"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6}"
            placeholder="请填写咨询内容"
            v-model="form.content">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit_tj(form)" size="medium">提交</el-button>
        </el-form-item>
      </el-form>
      <div class="clear"></div>
  </div>

</template>

<script>

export default{
  data(){
    return {
      loading:true,
      activeIndex: '3',

      form: {
        lxname:'',
        title:'',
        content:'',
        kftel:'',
        emaile:'',
     },
    }
  },
  props:['productid','title'],
  components: {

  },

  mounted () {
    console.log(this.productid)
    this.form.title = this.title
    this.recordapi();
  },
  methods:{

    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Member/MemberEnterprise",{'userid':userid}).then(res => {
          console.log(res);
          // that.form= res.form;
         this.loading = false
        });
    },


    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },



    onSubmit_tj(form) {
      var that = this;


      var userid = that.$cookieStore.getCookie('userid');
      
      if(userid==''){
        this.$message.error('请先登录');
        return;
      }
      
      
      that.form.userid = userid;
      that.form.productid = that.productid;
      console.log(this.form);
      const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (!reg.test(this.form.kftel)) {
            this.$message.error('请输入正确的手机号');
          return
      }
      that.$api.post("/Products/productzjzj",{data:this.form}).then(res => {
        console.log(res);
        this.$message.success(res.msg);
        that.form.lxname='';
        that.form.content='';
        that.form.kftel='';
        this.$emit('handleClosezj');
      });
    }

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/public/productzjzj.vue